  import { Navigate, Outlet } from "react-router-dom";
import auth from "../services/auth";

const ProtectedRoute = () => {
  const isAuth = auth.getAuth();

  if (!isAuth) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;